export const clim_chirps = `
with unpivot_result as (
    select *
    from chirps
), filter_year_admin as (
    select *
    from unpivot_result
    where admin2 = ? and YEAR >= ? and YEAR <= ?
), cap as (
    select 
    *,
    case 
        when value > ? then ?
        else value
    end as value_cap
    from filter_year_admin
), agr_cal as(
    select
    case when DEKAD > 18 then YEAR+1 else YEAR end as YEAR_ag,
    case when DEKAD < 19 then DEKAD + 36 else DEKAD end as DEKAD_ag,
    *
    from cap
), climatology as(
    select DEKAD_ag,
    avg(value_cap) as average_value
    from agr_cal
    group by DEKAD_ag
    order by DEKAD_ag
), output as(
    select DEKAD_ag,
    case 
        when average_value > ? then ?
        else average_value
    end as value
    from climatology
)

select * from output
`